import React, {Component} from 'react';
import { InputField } from '../../../../common/custom-form/input-filter-component';
import { SelectField } from '../../../../common/custom-form/select-filter.component';
export default class AccountLocationAddress extends Component {
    constructor(props) {
        super(props);
        this.state={
            inputValue:"",
            filterSelected: "", 
            selectFilter:[
                {
                    "FilterId":5,
                    "FilterName":"Account Number",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":4,
                    "FilterName":"Circuit ID",
                    "FilterType":"Textbox","Page":
                    "CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                },
                {
                    "FilterId":7,
                    "FilterName":"Circuit Status",
                    "FilterType":"Textbox",
                    "Page":"CircuitInventoryReport",
                    "State":true,"Createdby":null,
                    "DateCreated":"0001-01-01T00:00:00",
                    "Modifiedby":null,
                    "DateModified":null,
                    "DropDownFilterOpts":null
                }
               ],
        }
    }

    getDataOnTable() {    
       
        this.props.getData(false);
      }
    render(){
        return(
            <div className='manage-detail-container'>               
                <div className="manage-invoice-detail">                  
                    <SelectField label="Location Site"  options={this.state.selectFilter} selected={this.state.filterSelected} onChange={(e)=>this.setState({filterSelected:e.target.value})}/>
                    <InputField label="Address 1" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="Address 2" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="Location Type" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="CITY" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="STATE" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="COUNTRY/LOCATION" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />
                    <InputField label="ZIP" testInput={this.state.inputValue} onChange={(e)=>this.setState({inputValue:e.target.value})}  />                   
                </div>
                        
            </div>
        );
    }
}